import { render, staticRenderFns } from "./ed-layout-sidebar.vue?vue&type=template&id=519fbca5&scoped=true&"
import script from "./ed-layout-sidebar.ts?vue&type=script&lang=ts&"
export * from "./ed-layout-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./ed-layout-sidebar.scss?vue&type=style&index=0&id=519fbca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519fbca5",
  null
  
)

export default component.exports